/*eslint backbone/no-constructor:0 */
define('glu/grid/filter/dynamicTypeSearch',['require','../../layout','hbs!./fieldTypeSearch.hbs','../../util','../../locale','../../collection','../../flexDropdown','./fieldFuzzySearch','./manageFiltersLink','./gridFuzzySearch','./enumSearch','./numericSearch','./amountSearch','./../filter/numberRangeSearch','./dateRangeSearch','./multiSelectSearch'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        tpl = require('hbs!./fieldTypeSearch.hbs'),
        util = require('../../util'),
        locale = require('../../locale'),
        Collection = require('../../collection'),
        FlexDropdown = require('../../flexDropdown'),
        FieldFuzzySearch = require('./fieldFuzzySearch'),
        ManageFiltersLink = require('./manageFiltersLink'),
        GridFuzzySearch = require('./gridFuzzySearch'),
        EnumSearch = require('./enumSearch'),
        NumericSearch = require('./numericSearch'),
        AmountSearch = require('./amountSearch'),
        NumberRangeSearch = require('./../filter/numberRangeSearch'),
        DateRangeSearch = require('./dateRangeSearch'),
        MultiSelectSearch = require('./multiSelectSearch');

    function filterableColumns(column) {
        return !(column.has('filterable') && column.get('filterable') === false);
    }

    function getVisibleColumn(column) {
        return !(column.has('condition') && column.get('condition') === false);
    }

    return Layout.extend({
        template: tpl,
        className: 'grid-filter-selection',

        events: {
            'click @ui.$removeBtn': 'handleRemoveFilter'
        },

        regions: {
            searchContainer: '[data-control=searchContainer]',
            select: '.region-grid-select-filter'
        },

        collectionEvents: {
            'reset remove add change:condition': 'hideSearchView render'
        },

        ui: {
            '$removeBtn': 'button[data-control="removeFilter"]'
        },

        initialize: function() {
            this.filtersCollection = this.options.filtersCollection;
            if (this.options.model) {
                this.searchView = this.getSearchViewByType(this.options.model.get('type'), this.options.model);
            }

            this.first = this.options.first || false;

            if (this.options.masterCollection) {
                this.listenTo(this.options.masterCollection, 'grid:externalFilter', function() {
                    this.hideSearchView();
                });
            }

            if (!this.filtersCollection) {
                return;
            }

            this.listenTo(this.filtersCollection, 'grid:reopen:filter', this.reopenFilter);
        },

        createDropdown: function() {
            var dropdown;
            var flexDropdownOptions = {
                data: this.getDropDownData(),
                filter: false,
                multiSelect: false,
                showGroups: true,
                preSelectedIds: this.model && this.model.get('field') ? [this.model.get('field')] : [],
                defaultSelectMessage: locale.get('selectFields'),
                label: locale.get('filter'),
                showTooltip: false,
                showCancelIcon: false,
                clearBtn: false,
                disableMultiButton: true
            };

            if (this.options.disableAuxControl) {
                util.extend(flexDropdownOptions, {
                    customView: ManageFiltersLink,
                    customViewOptions: {
                        grid: this.options.grid,
                        collection: this.filtersCollection,
                        filterViewClass: this.options.filterViewClass,
                        columns: this.collection,
                        filterProc: this.options.filterProc
                    }
                });
            }

            dropdown = new FlexDropdown(flexDropdownOptions);

            this.listenTo(dropdown, 'selectionChanged:id', this.handleSelectType);

            return dropdown;
        },

        getDropDownData: function() {
            var itemsCollection = new Collection(this.collection.filter(filterableColumns)),
                visibleColumns = itemsCollection.filter(getVisibleColumn),
                data = [];

            var hiddenColumns = itemsCollection.where({
                condition: false
            });

            var mapper = function(item) {
                var id = item.get('field') || '';

                return {
                    id: id,
                    name: item.get('title') || id
                };
            };

            if (this.options.gridSearch) {
                data.unshift({
                    id: 'table',
                    name: locale.get('entireTable')
                });
            }

            data.push({
                id: 'visibleColumns',
                name: '',
                child: util.map(visibleColumns, mapper)
            });

            if (!hiddenColumns.length) {
                return data;
            }

            data.push({
                id: 'hiddenColumns',
                name: locale.get('notCurrentlyDisplayed'),
                child: util.map(hiddenColumns, mapper)
            });

            return data;
        },

        reopenFilter: function(filter) {
            if (!this.dropdown) {
                return;
            }

            this.dropdown.setSelectedIds(filter.get('field'));
        },

        /**
         * React to changes in the filter dropdown.
         *
         * @param ids type Array
         * @returns {*}
         */
        handleSelectType: function(ids) {
            var field = ids[0];

            if (!field) {
                // user selected the default value (ie, 'Select fields') or click clear button.
                this.hideSearchView();
            } else if (field === 'table') {
                // user selected the 'entire table' option.
                this.selectSearchByType('table', {});
            } else {
                var model = this.getModelByField(field),
                    grid = this.options.grid;

                this.selectSearchByType(model.get('type'), model, grid);
            }

            return field;
        },

        getModelByField: function(field) {
            var model = this.collection.find(function(column) {
                return field === column.get('field');
            });

            var filterModel = this.filtersCollection.find(function(filter) {
                return field === filter.get('field');
            });

            if (!filterModel) {
                return model.clone();
            }

            //need to merge filter model with columns model as columns model has additional filter parameters
            filterModel.set(util.extend(model.toJSON(), filterModel.toJSON()), {
                // to avoid re-rendering
                silent: true
            });

            return filterModel.clone();
        },

        selectSearchByType: function(type, model, grid) {
            type = type || 'string';
            var view = this.getSearchViewByType(type, model, grid);
            this.setSearchView(view);
            this.searchContainer.show(view);
        },

        setSearchView: function(view) {
            if (this.searchView) {
                this.$(this.searchContainer.el).removeClass(this.searchView.className);
            }

            this.searchView = view;
            this.$(this.searchContainer.el).addClass(this.searchView.className);

            this.listenTo(this.searchView, 'filter', this.handleSearchViewFilter);
        },

        disable: function() {
            this.disabled = true;
            this.$('.flex-dropdown .selection').addClass('disabled');
            if (this.searchView) {
                this.searchView.disable();
            }
        },

        enable: function() {
            this.disabled = false;
            this.$('.flex-dropdown .selection').removeClass('disabled');
            if (this.searchView) {
                this.searchView.enable();
            }
        },

        toggle: function() {
            return this.isDisabled() ? this.enable() : this.disable();
        },

        isDisabled: function() {
            return this.disabled === true;
        },

        handleRemoveFilter: function() {
            this.trigger('filter:remove', this);
        },

        handleSearchViewFilter: function(filter) {
            this.trigger('filter', filter);
        },

        onBeforeRender: function() {
            this.initializeDropdown();
        },

        onRender: function() {
            if (this.searchView && this.searchView.filterValue === undefined) {
                this.searchContainer.show(this.searchView);
            }

            this.showDropdown();
        },

        initializeDropdown: function() {
            if (this.dropdown) {
                this.dropdown.close();
            }
            this.dropdown = this.createDropdown();
        },

        showDropdown: function() {
            this.select.show(this.dropdown);
        },

        getSearchViewByType: function(type, model, grid) {
            var view;

            switch (type) {
                case 'table':
                    view = new GridFuzzySearch();
                    break;
                case 'date':
                    view = new DateRangeSearch({
                        model: model,
                        dateFormat: model.get('dateFormat')
                    });
                    view.setField(model.get('field'));
                    break;
                case 'enum':
                    view = new EnumSearch({
                        model: model
                    });
                    break;
                case 'number':
                    view = new NumericSearch({
                        model: model
                    });
                    break;
                case 'numberRange':
                    view = new NumberRangeSearch({
                        model: model
                    });
                    break;
                case 'amount':
                    view = new AmountSearch({
                        model: model
                    });
                    break;
                case 'multiselect':
                    view = new MultiSelectSearch({
                        model: model,
                        grid: grid
                    });
                    break;
                case 'string':
                default:
                    view = new FieldFuzzySearch({
                        model: model,
                        collection: this.collection
                    });
                    break;
            }

            this.listenTo(view, {
                'filter': this.hideSearchView,
                'filter:clear': this.clearFilter,
                'filter:remove': this.handleRemoveFilter
            });

            return view;
        },

        /**
         * Remove the existing search view (if present), leaving only the filter dropdown visible.
         */
        hideSearchView: function() {
            if (this.isClosed || !this.searchView || this.options.advancedSearch) {
                return;
            }

            this.searchView.close();
            this.searchView = null;

            this.dropdown.setSelectedIds('');
        },

        clearFilter: function(view) {
            var field = view.model.get('field');

            if (this.options.masterCollection) {
                this.options.masterCollection.trigger('grid:clear:filter:' + field, this);
            }

            this.options.filterProc.removeFilters(field);
            this.hideSearchView();
        },

        onClose: function() {
            if (!this.dropdown) {
                return;
            }

            this.dropdown.close();
        }
    });
});

